export default {
  miningDamage: 'Damage',
  miningToughness: 'Toughness',
  miningOreGain: 'Ore gain',
  miningOreCap: 'Ore capacity',
  miningRareEarthGain: 'Rare earth gain',
  miningPickaxeCraftingPower: 'Crafting power',
  miningPickaxeCraftingSlots: 'Crafting slots',
  miningPickaxePremiumCraftingSlots: 'Premium crafting slots',
  miningPickaxeCraftingQuality: 'Crafting purity',
  miningOreQuality: 'Ore quality',
  miningDepthDwellerSpeed: 'Depth dweller speed',
  miningDepthDwellerMax: 'Highest possible dweller depth',
  miningSmelterySpeed: 'Smeltery speed',
  miningSmelteryTemperature: 'Smeltery temperature',
  miningResinMax: 'Maximum resin',
  currencyMiningHeliumIncrement: 'Helium increment',
  currencyMiningNeonIncrement: 'Neon increment',
  currencyMiningArgonIncrement: 'Argon increment',
  currencyMiningKryptonIncrement: 'Krypton increment',
  currencyMiningXenonIncrement: 'Xenon increment',
  currencyMiningRadonIncrement: 'Radon increment',
  miningEnhancementBarsIncrement: 'Bar increment',
  miningEnhancementFinalIncrement: 'Enhancement increment',
  miningPrestigeIncome: 'Prestige income',
  miningBeaconPiercing: 'Piercing beacon',
  miningBeaconRich: 'Rich beacon',
  miningBeaconWonder: 'Wonder beacon',
  miningBeaconHope: 'Hope beacon',
  villageWorker: 'Workers',
  villageArtisan: 'Artisans',
  villageCounter: 'Counters',
  villageTaxRate: 'Tax rate',
  queueSpeedVillageBuilding: 'Building speed',
  villageOfferingPower: 'Offering power',
  villageResourceGain: 'All resource gain',
  villageMaterialGain: 'Material gain',
  villageMaterialCap: 'Material capacity',
  villageFoodGain: 'Food gain',
  villageMentalGain: 'Mental resource gain',
  villageHappiness: 'Happiness',
  villagePolicyTaxes: 'Tax policy',
  villagePolicyImmigration: 'Immigration policy',
  villagePolicyReligion: 'Religion policy',
  villagePolicyScanning: 'Scanning policy',
  villageHousingCap: 'Housing maximum level',
  villageWorkstationCap: 'Workstation maximum level',
  villagePollution: 'Pollution',
  villagePollutionTolerance: 'Pollution tolerance',
  villagePower: 'Power',
  villageLootGain: 'Loot gain',
  villageLootQuality: 'Loot quality',
  villageIngredientCount: 'Findable ingredients',
  villageIngredientBoxAmount: 'Ingredients per box',
  villagePrestigeIncome: 'Prestige income',
  hordeAttack: 'Attack',
  hordeHealth: 'Health',
  hordeRecovery: 'Recovery',
  hordeCritChance: 'Crit chance',
  hordeCritMult: 'Crit damage',
  hordeRevive: 'Revive',
  hordeMaxItems: 'Equipment capacity',
  hordeToxic: 'Toxicity',
  hordeFirstStrike: 'First strike',
  hordeSpellblade: 'Spellblade',
  hordeCutting: 'Cutting',
  hordeDivisionShield: 'Division shield',
  hordeDefense: 'Defense',
  hordeExecute: 'Execute',
  hordeHealing: 'Healing',
  hordeStunResist: 'Stun resist',
  hordeShieldbreak: 'Shieldbreak',
  hordeEnemyActiveStart: 'Enemy start cooldown',
  hordePhysicConversion: 'Physical damage conversion',
  hordeMagicConversion: 'Magical damage conversion',
  hordeBioConversion: 'Biological damage conversion',
  hordePhysicAttack: 'Physical damage dealt',
  hordeMagicAttack: 'Magical damage dealt',
  hordeBioAttack: 'Biological damage dealt',
  hordePhysicTaken: 'Physical damage taken',
  hordeMagicTaken: 'Magical damage taken',
  hordeBioTaken: 'Biological damage taken',
  hordeLoot: 'Basic loot',
  hordeItemChance: 'Equipment chance',
  hordeBossRequirement: 'Boss requirement',
  hordeRespawn: 'Respawn time',
  hordeHeirloomChance: 'Heirloom chance',
  hordeHeirloomAmount: 'Maximum heirloom gain',
  hordeHeirloomEffect: 'Heirloom effect',
  hordeNostalgia: 'Nostalgia',
  hordeCorruption: 'Corruption',
  hordeItemMasteryGain: 'Mastery point gain',
  hordeMinibossTime: 'Miniboss time',
  hordeShardChance: 'Mystical shard chance',
  hordeEnergy: 'Energy',
  hordeEnergyRegen: 'Energy regeneration',
  hordeMana: 'Mana',
  hordeManaRegen: 'Mana regeneration',
  hordeHaste: 'Haste',
  hordeStrength: 'Strength',
  hordeIntelligence: 'Intelligence',
  hordeAutocast: 'Autocast slots',
  hordeMaxTrinkets: 'Trinket capacity',
  hordeExpBase: 'Level time',
  hordeExpIncrement: 'Level increment',
  hordeTrinketGain: 'Maximum trinket gain',
  hordeTrinketQuality: 'Trinket quality',
  hordeMaxSacrifice: 'Maximum sacrifice',
  hordeSkillPointsPerLevel: 'Skill points per level',
  hordePrestigeIncome: 'Prestige income',
  powerHeirloomEffect: 'Power effect',
  fortitudeHeirloomEffect: 'Fortitude effect',
  wealthHeirloomEffect: 'Wealth effect',
  spiritHeirloomEffect: 'Spirit effect',
  sharpsightHeirloomEffect: 'Sharpsight effect',
  holdingHeirloomEffect: 'Holding effect',
  reapingHeirloomEffect: 'Reaping effect',
  remembranceHeirloomEffect: 'Remembrance effect',
  expertiseHeirloomEffect: 'Expertise effect',
  mysteryHeirloomEffect: 'Mystery effect',
  farmExperience: 'Crop experience',
  farmGoldChance: 'Gold chance',
  farmTiles: 'Farm tiles',
  farmGrow: 'Grow time',
  farmOvergrow: 'Overgrow',
  farmRareDropChance: 'Rare drop chance',
  farmMystery: 'Mystery',
  farmDnaNext: 'Next prestige DNA',
  farmCropGain: 'Crop gain',
  farmAllGain: 'All harvest gain',
  farmCropCost: 'Crop cost',
  farmFertilizerCost: 'Fertilizer cost',
  farmLuckyHarvestMult: 'Lucky harvest gain',
  farmHuntChance: 'Hunt chance',
  galleryInspirationBase: 'Inspiration time base',
  galleryInspirationIncrement: 'Inspiration time increment',
  galleryInspirationStart: 'Starting inspiration',
  galleryColorGain: 'All color gain',
  galleryColorDrumChance: 'All drum chance',
  galleryColorDrumCap: 'All drum cap',
  galleryRedConversion: 'Red conversion',
  galleryRedDrumChance: 'Red drum chance',
  galleryOrangeConversion: 'Orange conversion',
  galleryOrangeDrumChance: 'Orange drum chance',
  galleryYellowConversion: 'Yellow conversion',
  galleryYellowDrumChance: 'Yellow drum chance',
  galleryGreenConversion: 'Green conversion',
  galleryGreenDrumChance: 'Green drum chance',
  galleryBlueConversion: 'Blue conversion',
  galleryBlueDrumChance: 'Blue drum chance',
  galleryPurpleConversion: 'Purple conversion',
  galleryPurpleDrumChance: 'Purple drum chance',
  "galleryDeep-orangeConversion": 'Red-orange conversion',
  "galleryDeep-orangeDrumChance": 'Red-orange drum chance',
  galleryAmberConversion: 'Golden conversion',
  galleryAmberDrumChance: 'Golden drum chance',
  "galleryLight-greenConversion": 'Light green conversion',
  "galleryLight-greenDrumChance": 'Light green drum chance',
  galleryTealConversion: 'Teal conversion',
  galleryTealDrumChance: 'Teal drum chance',
  "galleryLight-blueConversion": 'Light blue conversion',
  "galleryLight-blueDrumChance": 'Light blue drum chance',
  galleryPinkConversion: 'Pink conversion',
  galleryPinkDrumChance: 'Pink drum chance',
  galleryShapeGain: 'Shape gain',
  gallerySpecialShapeChance: 'Special shape chance',
  gallerySpecialShapeMult: 'Special shape multiplier',
  galleryCanvasSize: 'Canvas size',
  galleryCanvasSpeed: 'Canvas speed',
  miningCardCap: 'Mining card capacity',
  villageCardCap: 'Village card capacity',
  hordeCardCap: 'Horde card capacity',
  galleryCardCap: 'Gallery card capacity',
  treasureSlots: 'Treasure slots',
  cryolabMaxFeatures: 'Maximum frozen features',
  merchantOffers: 'Merchant offers',
  bankInvestmentSize: 'Investment size',
  bankLoanSize: 'Loan size',
  bankCardPackChance: 'Bank card pack chance',
  cindersProductionFirefly: 'Light gain (firefly)',
  cindersProductionGlowshroom: 'Light gain (glowshroom)',
  cindersProductionGlowfish: 'Light gain (glowfish)',
  cindersProductionLantern: 'Light gain (lantern)',
  cindersProductionCampfire: 'Light gain (campfire)',
  cindersProductionCoral: 'Light gain (coral)',
  cindersProductionJellyfish: 'Light gain (jellyfish)',
  cindersProductionNightbloom: 'Light gain (nightbloom)',
  cindersProductionNeonlight: 'Light gain (neon light)',
  cindersProductionSun: 'Light gain (sun)',
  cindersFirstProducerCost: 'First producer cost',
  cindersNonFirstProducerCost: 'Non-first producer cost',
  cindersUpgradeLightCost: 'Upgrade light cost',
  cindersUpgradeProducerRequirement: 'Upgrade producer requirement',
  cindersCandlePower: 'Candle power',
  bloomInventorySize: 'Inventory size',
  bloomBreederSize: 'Breeder size',
  bloomDaisyChance: 'Daisy tier chance',
  bloomPoppyChance: 'Poppy tier chance',
  bloomIrisChance: 'Iris tier chance',
  bloomLilyChance: 'Lily tier chance',
  bloomOrchidChance: 'Orchid tier chance',
  bloomCornflowerChance: 'Cornflower tier chance',
  bloomDaisyBreedTime: 'Daisy breed time',
  bloomPoppyBreedTime: 'Poppy breed time',
  bloomIrisBreedTime: 'Iris breed time',
  bloomLilyBreedTime: 'Lily breed time',
  bloomOrchidBreedTime: 'Orchid breed time',
  bloomCornflowerBreedTime: 'Cornflower breed time',
  weatherChaosFishingPower: 'Fishing power',
  weatherChaosFishSizeMax: 'Maximum fish size',
  weatherChaosFishSizeAverage: 'Average fish size',
  weatherChaosFishingTime: 'Fishing time',
  weatherChaosFishDoubleChance: 'Double fish chance',
  weatherChaosIgnoreWeather: 'Ignore weather',
  weatherChaosFishChance: 'Fish chance',
  weatherChaosTreasureChance: 'Treasure chance',
  weatherChaosAlgaeWeight: 'Algae weight',
  weatherChaosDriftwoodWeight: 'Driftwood weight',
  weatherChaosPlasticWeight: 'Plastic weight',
  weatherChaosTrashGain: 'Trash gain',
  summerFestivalBuildQueueSlots: 'Build queue slots',
  summerFestivalBuildQueueSpeed: 'Build queue speed',
  summerFestivalMaterialGain: 'Material gain',
  summerFestivalMaterialStackCap: 'Material stack capacity',
  nightHuntFindableIngredients: 'Findable ingredients',
  nightHuntIngredientSize: 'Ingredient size',
  nightHuntFavouriteIngredientSize: 'Favourite ingredient size',
  nightHuntMaxIngredients: 'Ritual ingredients',
  nightHuntBonusIngredientCount: 'Bonus ingredients',
  nightHuntBonusIngredientAmount: 'Bonus ingredient amount',
  nightHuntRitualStability: 'Ritual stability',
  nightHuntRitualSuccessChance: 'Ritual success chance',
  nightHuntRitualHintChance: 'Ritual hint chance',
  nightHuntRitualFamiliarity: 'Ritual familiarity',
  snowdownAttack: 'Attack',
  snowdownHealth: 'Health',
  snowdownDefense: 'Defense',
  snowdownCritRating: 'Crit rating',
  snowdownBlockRating: 'Block rating',
  snowdownPetAttack: 'Pet attack',
  snowdownPetHealth: 'Pet health',
  snowdownPetDefense: 'Pet defense',
  snowdownPetCritRating: 'Pet crit rating',
  snowdownPetBlockRating: 'Pet block rating',
  snowdownAllAttack: 'All attack',
  snowdownAllHealth: 'All health',
  snowdownAllDefense: 'All defense',
  snowdownRevengeStats: 'Revenge stats',
  snowdownRevengeCrit: 'Revenge crit rating',
  snowdownRevengeBlock: 'Revenge block rating',
};
